import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  topPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  selectorsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
    flexWrap: 'wrap',
  },
  title: {
    minWidth: 180,
  },
  selectors: {
    display: 'flex',
    gap: theme.spacing(1),
    minWidth: 0,
    flexWrap: 'nowrap',
    marginLeft: 'auto',
  },
  actionsRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    width: '100%',
    flexWrap: 'wrap',
  },
  selector: {
    minWidth: 260,
  },
  blocksList: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  },
  blockRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  blockContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    minWidth: 0,
    flex: 1,
  },
  blockValue: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflow: 'hidden',
  },
  blockActions: {
    display: 'flex',
    gap: theme.spacing(0.5),
    flexShrink: 0,
  },
  emptyState: {
    padding: theme.spacing(2),
  },
  bottomActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  dragItem: {
    padding: theme.spacing(1.25, 1.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(1),
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  dragTypeLabel: {
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: 700,
    textTransform: 'lowercase',
    flexShrink: 0,
  },
  dragPreviewText: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  dragOver: {
    borderColor: theme.palette.primary.main,
  },
}));
